import YouTubeIcon from './YouTubeIcon';

export default YouTubeIcon;
